import React from 'react';
import { useEffect, useRef } from 'react';

import './index.module.less';

import Item from './Item';

interface IProps {
  onCancel: () => void;
  items: any[] | null;
  onSelectItem: (item : any, isSearch?: boolean) => void;
  selectedLocation: any;
  onSearch: (value: string) => void;
}

const SearchList = (props: IProps) => {
  const { items, selectedLocation, onSelectItem, onCancel } = props;
  const inputRef = useRef(null);

  const preventEvent = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  }

  const inputValue = (e: any) => {
    const value = e.target.value || '';
    props.onSearch(value);
  }

  const select = (item: any) => {
    onSelectItem && onSelectItem(item, true);
  }

  const renderLocations = (): (JSX.Element| JSX.Element[]) => {
    let Items = null;
    if(items?.length) {
      Items = items.map((item: any) => {
        return <Item item={ item } onSelect={ select } selectItem={ selectedLocation } />
      });
    }else if(items && !items.length){
      Items = (<div styleName="empty">无结果</div>)
    }
    return Items;
  }

  const cancel = () => {
    inputRef.current.blur();
    setTimeout(() => {
      onCancel && onCancel();
    }, 100)
  }

  useEffect(() => {
    inputRef.current.focus();
  }, [])

  return (
    <div styleName="modal-mask" onClick={ cancel }>
      <div
        className="flex"
        styleName="modal"
        style={{ height: '80%' }}
        onClick={ preventEvent }
      >
        <div className="flex" styleName="input-wrapper" style={{ background: 'transparent' }}>
          <div className="flex" styleName="input-content">
            <i className="iconfont icon-sousuo" styleName="input-icon" />
            <input
              ref={ inputRef }
              styleName="input"
              placeholder="搜索地点名称"
              onChange={ inputValue }
              autoFocus={ true }
            />
          </div>
          <div styleName="input-cancel" onClick={ cancel }>取消</div>
        </div>
        <div styleName="list">
          { renderLocations() }
        </div>
      </div>
    </div>
  )
}

export default SearchList;